<template>
	<div>
		<BaseAccordionController :expand_accondion="true" :accordion_header="getStateWithParam('atraction')">
			<template v-slot:component>
				<MapController
					:key="map_render"
					:map_data="map_data"
					:from_where="from_where"
					:icon_url="icon_url"
					:legent_button="false"
					:fitbounds="fitbounds"
					class="accordion-card-middle"
				>
					<l-marker
						v-for=" marker in attractions "
						:key="marker.properties.poi_id"
						:lat-lng="getMarkerCoordinates(marker.geometry.coordinates)"
						:icon="getIconForMarker(marker.properties.category.icon)"
						@click="showPoiDetails(marker.properties.poi_id)"
					>

					</l-marker>
				</MapController>
			</template>
		</BaseAccordionController>
		<TurisemDialog :showdialog="showSearchDialog" :list_turistic_point="list_turistic_point" />
	</div>
</template>

<script>
import poi from '@/config/api/api_events/poi.js';
import map_helper from '@/config/js_helper/map_helper';
import MapController from "@/components/cards/MapController.vue";
import { LMarker } from "vue2-leaflet";
import TurisemDialog from '@/components/dialog/TurisemDialog.vue';
export default {
	name: 'TurisemMap',
	props: {},
	components: {
		//MapCard,
		MapController,
		LMarker,
		TurisemDialog,
	},
	data() {
		return {
			from_where: 8,
			map_render: 800,
			expand_accondion: true,
			map_data: {
				geodata:[],
				kategorite:[]
			},
			list_turistic_point: [],
			icon_url: [],
			fitbounds: 0,
			dataloaded: false
		};
	},
	computed: {
		attractions(){
			let list = []
			if (this.map_data.geodata) {
				//list = this.map_data.geodata.features.filter(item => item.properties.category_id == '7')
				list = this.map_data.geodata.features
			}
			return list
		},
		getLangTypeToUse() {
			return this.$store.state.type_language;
		},
		showSearchDialog() {
			return this.$route.name == 'turisem_search';
		},
	},
	watch: {
		attractions(){
			this.fitbounds ++
		},
		$route(to) {
			if (to.name === 'turisem_map' && this.dataloaded) {
				map_helper.refreshMap();
				this.$store.state.active_loader = false;
			}
		},
		getLangTypeToUse(){
			this.getPoiDataTurisem()
		}
	},
	mounted() {
		this.getPoiDataTurisem();
	},
	methods: {
		getPoiDataTurisem() {
			poi.getPoi(this.getLangTypeToUse)
				.then((response) => {
					this.map_data.kategorite = response.kategorite
					let attractions = response.geodata
					let categoriesobj = {}
					this.map_data.kategorite.forEach(category =>{
						categoriesobj[category.id] = category
					})
					attractions.features.forEach(attraction => {
						attraction.properties.category = categoriesobj[attraction.properties.category_id]
						this.list_turistic_point.push({
							id: attraction.properties.poi_id,
							image: attraction.properties.poi_simg_src,
							title: attraction.properties.poi_title,
							description: attraction.properties.poi_desc,
						})
					}, this);
					this.map_data.geodata = attractions
					this.$store.state.active_loader = false;
					this.dataloaded = true
				})
				.catch((err) => {
					console.log(err);
				});
		},
		getStateWithParam(param) {
			return this.$store.getters.getLanguageParameters(param);
		},
		getMarkerCoordinates(marker){
			return [marker[1], marker[0]]
		},
		getIconForMarker(icon_url) {
			return map_helper.getIcon(icon_url);
		},
		showPoiDetails(id){
			this.$router.push({ name: 'TurisemDetail', params:{point_id: id} })
		}
	},
};
</script>

<style lang="scss" src="./TurisemMap.scss"></style>
